import React, { useContext } from 'react';
import { Box, Divider, Flex, Text } from 'pcln-design-system';
import { Img, ListingCardWrapper } from './HotlListingCard.styles';
import Header from './components/Header/Header';
import Ratings from './components/Ratings/Ratings';
import Price from './components/Price/Price';
import { ChatbotDataContext } from '../../context/ChatbotDataContext';
import { transformSOPQName } from '../../utils';
import { BookHotelNowButton } from '../BookHotelNowButton';
import { v4 as uuidV4 } from 'uuid';
import { ChooseHotelRoomButton, handleChooseHotelRoomButtonClick } from '../ChooseHotelRoomButton';
import { HotelAISummaryMemo } from './HotelAISummary';
import { buildHotelDetailURL } from './buildHotelDetailURL';
import { useRealTimeContext } from '../../hooks/useRealTimeContext';
import ExpressDealBadge from './components/ExpressDealBadge/ExpressDealBadge';
const HotelListingCard = ({
  listingProps,
  hotel,
  args
}) => {
  var _a, _b;
  const {
    imageSrc,
    headerText,
    ratingsProps,
    priceProps
  } = listingProps !== null && listingProps !== void 0 ? listingProps : {};
  const {
    setiValues,
    fetchRequestOptions,
    shouldDisplayGenHotelFeature,
    submitChatMessagesPayload
  } = useContext(ChatbotDataContext);
  const {
    startRealTime
  } = useRealTimeContext();
  const {
    starRating,
    location,
    pclnPropertyTypeId,
    hotelType,
    description,
    ratesSummary,
    itemKey,
    hotelAISummary
  } = hotel !== null && hotel !== void 0 ? hotel : {};
  const isExpressDeal = hotelType === 'SOPQ';
  const shouldDisplayCheckoutButton = setiValues.shouldDisplayCheckoutButton;
  const transformSopqNameArgs = {
    starRating,
    location,
    pclnPropertyTypeId
  };
  const propertyName = isExpressDeal && !hotel.name ? transformSOPQName(transformSopqNameArgs) : hotel.name;
  const detailURL = buildHotelDetailURL(args, hotel);
  const {
    priceDisplayRegulation,
    minCurrencyCodeSymbol,
    minCurrencyCode,
    nightlyRateIncludingTaxesAndFees,
    grandTotal,
    minPrice,
    priceKey
  } = ratesSummary || {};
  const showHotelPrice = priceDisplayRegulation === 'TOTAL_PRICE_PROMINENT' ? minCurrencyCodeSymbol && !isNaN(nightlyRateIncludingTaxesAndFees) && !isNaN(grandTotal) : minCurrencyCodeSymbol && !isNaN(minPrice) && !isNaN(grandTotal);
  return React.createElement(ListingCardWrapper, {
    borderRadius: 'xl',
    boxShadow: 'lg',
    onClick: handleChooseHotelRoomButtonClick({
      hotelId: hotel.hotelId,
      args,
      detailURL
    }),
    mb: '20px',
    pb: '10px',
    bg: startRealTime ? 'text.lightest' : 'null'
  }, React.createElement(Box, null, isExpressDeal && React.createElement(ExpressDealBadge, null), React.createElement(Img, {
    src: imageSrc
  })), React.createElement(Box, {
    p: 2,
    pb: '0'
  }, React.createElement(Box, {
    height: '120px'
  }, React.createElement(Box, null, React.createElement(Header, Object.assign({}, headerText))), hotelAISummary ? React.createElement(Text, {
    fontSize: 0,
    lineHeight: '20px',
    pb: 1,
    pt: 2
  }, hotelAISummary) : React.createElement(HotelAISummaryMemo, {
    shouldDisplayGenHotelFeature: shouldDisplayGenHotelFeature,
    propertyName: propertyName,
    isExpressDeal: isExpressDeal,
    fetchRequestOptions: fetchRequestOptions,
    description: description,
    starRating: starRating,
    hotelAmenities: (_a = hotel.hotelFeatures) === null || _a === void 0 ? void 0 : _a.hotelAmenities,
    petDescription: (_b = hotel === null || hotel === void 0 ? void 0 : hotel.policies) === null || _b === void 0 ? void 0 : _b.petDescription
  })), React.createElement(Box, {
    mt: 3,
    height: '20px'
  }, React.createElement(Box, null, React.createElement(Ratings, Object.assign({}, ratingsProps)), ' '))), React.createElement(Divider, {
    width: 1,
    my: 1
  }), React.createElement(Flex, {
    p: 0,
    px: 2,
    pb: 2,
    height: ['100px', '70px']
  }, showHotelPrice ? React.createElement(Price, Object.assign({}, priceProps)) : null), shouldDisplayCheckoutButton ? React.createElement(Flex, {
    p: 0,
    px: 2,
    mt: 2
  }, React.createElement(ChooseHotelRoomButton, {
    hotelId: hotel.hotelId,
    args: args,
    buttonProps: {
      variation: 'subtle',
      width: '100%'
    },
    detailURL: detailURL,
    buttonCopy: 'Choose Room'
  }), React.createElement(BookHotelNowButton, {
    buttonProps: {
      variation: 'fill',
      color: 'secondary',
      width: '100%',
      ml: 2
    },
    cguid: submitChatMessagesPayload === null || submitChatMessagesPayload === void 0 ? void 0 : submitChatMessagesPayload.cguid,
    rguid: uuidV4(),
    itemKey: itemKey,
    priceKey: priceKey,
    nightlyRateIncludingTaxesAndFees: nightlyRateIncludingTaxesAndFees,
    minCurrencyCode: minCurrencyCode,
    minCurrencyCodeSymbol: minCurrencyCodeSymbol
  })) : null);
};
export default HotelListingCard;